import React from "react";
import { useRoutes } from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { Box, CssBaseline } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Toast from "./components/base/Toast";
import { handleToastState } from "./slices/shared";
import { useDispatch, useSelector } from "./store";
import theme from "./theme";
import routes from "./routes";

interface Props {}

const App: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const { toastStatus, globalLoadingState } = useSelector(
    (state) => state.shared
  );

  const handleCloseToast = () => {
    dispatch(handleToastState({ open: "none", message: "" }));
  };

  const content = useRoutes(routes());

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 2,
          backgroundColor: "rgba(38,84,158,0.5)",
        }}
        open={globalLoadingState.isLoading}
      >
        <Box
          sx={{
            fontSize: "100px",
            position: "absolute",
            overflow: "hidden",
            display: "inline-block",
            animation: "blink 2s infinite linear",
            "@keyframes blink": {
              "0%, 100%": { opacity: 1 },
              "50%": { opacity: 0.1 },
            },
          }}
        >
          <img height={300} src={"/static/images/SVPro.png"} alt="logo" />
        </Box>
      </Backdrop>
      <Toast
        open={toastStatus.open !== "none"}
        message={toastStatus.message}
        type={toastStatus.open !== "none" ? toastStatus.open : "info"}
        handleClose={handleCloseToast}
      />
      {content}
    </MuiThemeProvider>
  );
};

export default App;
